import React, { useMemo } from "react";
import CustomSelect from "../CustomSelect";
import { useTranslation } from "../../hooks/useTranslation";

const getCategoryName = (category, lang) => {
    const translation = category?.translations?.find(t => t.languageIsoCode === lang);
    return translation ? translation.productCategoryName : category?.productCategoryName;
};

const getProductsAmount = (category, products, selectedProperty, selectedBrand, properties) => {
    let selectedPropertyId = selectedProperty?.toString().replace("property-", "");
    let selectedBrandId = selectedBrand?.toString().replace("brand-", "");
    let brandPropertyIds = selectedBrandId && selectedBrandId !== "all"
        ? properties?.filter(p => p.brandId == selectedBrandId).map(p => p.propertyId)
        : null;

    return products?.filter(p =>
        p?.categories?.some(c => c?.productCategoryId === category?.productCategoryId) &&
        (!selectedPropertyId || selectedPropertyId === "all" || p.propertyId == selectedPropertyId || p.propertyId == -1) &&
        (!brandPropertyIds || brandPropertyIds.includes(p.propertyId) || p.propertyId == -1)
    ).length;
}


const CategoryFilter = ({ categories, selectedValue, setSelected, lang, products, selectedProperty, selectedBrand, properties }) => {
    const { t } = useTranslation();

    const optionsWithAll = useMemo(() => [
        { value: "category-all", label: t("AllCategories") },
        ...categories
            .map(o => ({ label: getCategoryName(o, lang), value: `category-${o.productCategoryId}`, amount: getProductsAmount(o, products, selectedProperty, selectedBrand, properties) }))
            .filter(o => o.amount === undefined || o.amount > 0)
    ], [categories, products, lang, selectedProperty, selectedBrand, properties]);

    if (optionsWithAll.length <= 1) return null;

    return (
        <div className="filter-section">
            <CustomSelect
                options={optionsWithAll}
                onChange={setSelected}
                selectedValue={selectedValue}
                id="filter-category"
                placeholder={t("AllCategories")}
                label={t("AllCategories")}
                className="products-filter"
                classNameButton="dropdown-toggle btn btn-primary"
                classNameList="dropdown-menu show"
                renderOption={(item) => (
                    <>
                        <span>{item.label}</span>
                        {item.amount && <span className="amount" aria-label={item.amount + " " + t("Results") }>({item.amount})</span>}
                    </>
                )}
            />
        </div>
    );
};

export default CategoryFilter;
